import CreateTrainingTypeIcon from "../../../components/Common/SvgIcons/ManageIcons/CreateTrainingTypeIcon";
import DeleteIcon from "../../../components/Common/SvgIcons/TableIcons/DeleteIcon";
import EditIcon from "../../../components/Common/SvgIcons/TableIcons/EditIcon";
import { tableColumnTypes } from "../../tableColumnTypes";

export let eventCreateTrainingType = {
  label: "Create Training Type",
  path: (tenantName) => `/${tenantName}/manage/createTrainingType`,
  icon: CreateTrainingTypeIcon,
  // navLinks: (navigate) => [
  //   {
  //     key: 1,
  //     label: "Manage Events",
  //     path: `/${localStorage.getItem("tenantName")}/events`,
  //     onClick: () => navigate(`/${localStorage.getItem("tenantName")}/events`),
  //   },
  //   // {
  //   //   key: 2,
  //   //   label: eventCreateTrainingType.label,
  //   //   path: `${eventCreateTrainingType.path}`,
  //   //   onclick: () => navigate(`${eventCreateTrainingType.path}`),
  //   // },
  // ],
  // columns: (handleDelete, handleEdit) => [
  //   {
  //     ID: 1,
  //     name: "Training Name",
  //     fieldName: "Name",
  //     value: (row) => row.name,
  //     sort: true,
  //     type: tableColumnTypes.STRING,
  //   },
  //   {
  //     ID: 2,
  //     name: "Action",
  //     fieldName: "",
  //     value: (row) => (
  //       <>
  //         <span
  //           onClick={() => handleDelete(row.TypeId)}
  //           style={{ visibility: row.CanDelete ? "visible" : "hidden" }}
  //         >
  //           <DeleteIcon />
  //         </span>
  //         <span onClick={() => handleEdit(row.TypeId, row.Name)}>
  //           <EditIcon />
  //         </span>
  //       </>
  //     ),
  //     sort: false,
  //   },
  // ],
};
